import { FunctionComponent, PropsWithChildren } from 'react';
import { RunSectionProps } from './RunSectionProps';

export const RunSection: FunctionComponent<PropsWithChildren<RunSectionProps>> = ({ title, children }) => {
  return (
    <div className="pb-8 space-y-2">
      <div className="items-start v-stack">
        <h4 className="flex-1 font-medium tracking-wide text-text-secondary">{title}</h4>
      </div>
      {children}
    </div>
  );
};
